module.exports = __webpack_public_path__ + "img/curso_1_texto.38a591fe.png";